import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { ShieldCheck } from "lucide-react";

export const LegalConsentGate = () => {
  const { user, checkAuth } = useAuth();
  const [privacy, setPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user?.requires_consent) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/me/accept-legal", { accept_privacy: privacy, accept_terms: terms });
      await checkAuth();
      toast.success("Thank you — preferences saved");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not save");
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="consent-gate">
      <div className="w-full max-w-lg rounded-xl bg-white shadow-xl p-7">
        <div className="flex items-center gap-2 text-[#2563EB]"><ShieldCheck className="h-5 w-5" /><p className="overline">Privacy</p></div>
        <h2 className="mt-2 text-xl font-bold tracking-tight text-slate-900">We've updated our policies</h2>
        <p className="mt-2 text-sm text-slate-600">To continue using Airava, please review and accept the Privacy Policy.</p>
        <div className="mt-5 space-y-3">
          <label className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer">
            <Checkbox checked={privacy} onCheckedChange={(v) => setPrivacy(!!v)} className="mt-0.5" data-testid="consent-privacy" />
            <span>I have read and accept the <a href="/privacy" target="_blank" rel="noreferrer" className="text-[#2563EB] hover:underline">Privacy Policy</a>.</span>
          </label>
          <label className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer">
            <Checkbox checked={terms} onCheckedChange={(v) => setTerms(!!v)} className="mt-0.5" data-testid="consent-terms" />
            <span>I accept the <a href="/terms" target="_blank" rel="noreferrer" className="text-[#2563EB] hover:underline">Terms of Use</a>.</span>
          </label>
        </div>
        <Button onClick={accept} disabled={!privacy || busy} className="mt-6 w-full bg-[#2563EB] hover:bg-[#1d4ed8]" data-testid="consent-accept-btn">
          {busy ? "Saving…" : "Accept and continue"}
        </Button>
      </div>
    </div>
  );
};
